import { FC } from 'react';
import { TaskStatus } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import { useDashboardWidget } from '@frontend/grid-dashboard';
import { Text } from '@frontend/design-system';
import { getTaskStatusLabel, getTaskCount } from '../../../utils/widgets';
import { CountSkeletonLoader } from './loaders/skeleton-loaders';
import { countText, statusText, countContainer } from './styles';

interface TaskCountProps {
  count: number;
  status: TaskStatus;
  isLoading: boolean;
}

export const TaskCount: FC<TaskCountProps> = ({ count, status, isLoading }) => {
  const { currentSize } = useDashboardWidget();

  // If the current size is not large-wide, we don't want to show the task count
  if (currentSize !== 'large-wide') return null;

  if (isLoading) {
    return <CountSkeletonLoader />;
  }

  return (
    <span css={countContainer}>
      <Text weight='bold' css={countText}>
        {getTaskCount(count)}
      </Text>
      <Text css={statusText}>{getTaskStatusLabel(status)}</Text>
    </span>
  );
};
